import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import {AppState} from "./configuration";

const XHR = require("i18next-xhr-backend/i18nextXHRBackend");

let customPath:false|string = false;

const loadPath = () => {
	return customPath || (process.env.NODE_ENV === "development" ? "resources/{{ns}}/i18n.properties" : "resources/{{ns}}/i18n_{{lng}}.properties")
};

const options: any = {
	debug: false,
	defaultNS: "i18n",
	ns: "i18n",
	load: "languageOnly",
	fallbackLng: false,
	backend: {
		loadPath: loadPath,
		parse: parseBundle,
	},
};

/**
 * Initiate the translator
 */
function LoadTranslator() {
	return new Promise((resolve, reject) => {
		i18next
		.use(LanguageDetector)
		.use(XHR)
		.init(options, (error: Error, translation: any) => {
			if (error) {
				reject(error);
			} else {
				resolve(i18next);
			}
		});
	});
}

/**
 * Convert properties type of a translation file to JSON
 */
function parseBundle(bundle: string, location: string) {
	const output: any = {};
	for (const line of bundle.split(/\r?\n/)) {
		const item = line.split("=");
		if (item.length === 2 && item[0][0] !== "#") {
			output[item[0]] = JSON.parse('"' + item[1].replace(/"/g, '\\"') + '"');
		}
	}
	return output;
}

/**
 * Change UI language bundle
 */
export function ChangeLanguage(language: string) {
	return new Promise((resolve, reject) => {
		i18next.changeLanguage(language, (error, translation) => {
			if (error) {
				reject(error);
			} else {
				AppState.language = i18next.language;
				resolve(i18next);
			}
		});
	});
}

/**
 * Get the translation provider object. If no supported language is detected, falls back to english
 */
export async function GetTranslationProvider(i18nCustomFileUrl:false|string = false): Promise<any> {
	try {
		customPath = i18nCustomFileUrl;
		await LoadTranslator();
	} catch (error) {
		// Load english if detected language fails, or loading external resource failed
		await ChangeLanguage("en");
		if (customPath) {
			// Load default translator
			return await GetTranslationProvider(false);
		}
	}
	AppState.language = i18next.language;
	return i18next;
}

export const Bundle = i18next;
